/*
 *  ************************************************************************
 *  *  © [2015 - 2020] Quintype Technologies India Private Limited
 *  *  All Rights Reserved.
 *  *************************************************************************
 */
export const isRelatedStoriesExtraAdSlotEnabled = (publisherSettings, config = {}) => {
  const adSlotFlag = publisherSettings["related_story_extra_ad_slot"];
  const isadSlotEnabledForPublisher =
    publisherSettings["related_story_extra_ad_slot"] &&
    publisherSettings["related_story_extra_ad_slot"].indexOf(config["publisher-id"]) > -1;
  return adSlotFlag && isadSlotEnabledForPublisher;
};
